import { create } from 'zustand'
import { combine } from 'zustand/middleware'

interface TabSelector {
  tabs: string[]
  currentTab: string | null
}

const defaultValues: TabSelector = {
  tabs: [],
  currentTab: null,
}

export const useTabSelectorStore = create(
  combine(defaultValues, (set) => ({
    setCurrentTab: (currentTab: string | null) => set({ currentTab }),
    setTabs: (tabs: string[]) => set({ tabs }),
  }))
)
